class TableService {
  constructor(config, httpDim) {
    this.config = config;
    this.httpDim = httpDim;
  }

  getTableData(uri) {
    let url = this.config.apiRoot + uri;
    let config = this.config;

    return this.httpDim.get(url,config);
  }
}

TableService.$inject = ['config', 'httpDim'];

export
default TableService;


// WEBPACK FOOTER //
// ./app/common/tableService/tableService.service.js